@if (section(); as s) {
  <app-section-wrapper [id]="s.id" [title]="s.title" [background]="s.background">
    <div class="portfolio-grid stagger">
      @for (project of s.items; track project.title) {
        <div class="portfolio-card">
          <div class="portfolio-card__tag">{{ project.tag }}</div>

          <div class="portfolio-card__preview">
            <img
              [src]="project.imageSrc"
              [alt]="project.imageAlt"
              loading="lazy"
              decoding="async"
            />
          </div>

          <h3 class="portfolio-card__title">{{ project.title }}</h3>

          <div class="portfolio-card__block">
            <span class="portfolio-card__label">Probléma</span>
            <p>{{ project.problem }}</p>
          </div>

          <div class="portfolio-card__block">
            <span class="portfolio-card__label">Megoldás</span>
            <p>{{ project.solution }}</p>
          </div>

          <!-- <ul class="portfolio-card__proofs">
            @for (proof of project.proofs; track proof) {
              <li>
                <mat-icon>check</mat-icon>
                <span>{{ proof }}</span>
              </li>
            }
          </ul> -->

          <a
            [href]="project.ctaHref"
            target="_blank"
            rel="noopener"
            mat-stroked-button
            class="portfolio-card__cta"
          >
            {{ project.ctaLabel }}
            <mat-icon>open_in_new</mat-icon>
          </a>
        </div>
      }
    </div>
  </app-section-wrapper>
}
